var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.2744C20 12.6541 19.7178 12.9679 19.3518 13.0176L19.25 13.0244L4.25 13.0244C3.83579 13.0244 3.5 12.6886 3.5 12.2744C3.5 11.8947 3.78215 11.5809 4.14823 11.5313L4.25 11.5244L19.25 11.5244C19.6642 11.5244 20 11.8602 20 12.2744Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.829 17.7673C11.1225 18.0595 11.1235 18.5344 10.8313 18.8279C10.5656 19.0948 10.149 19.1199 9.85489 18.9027L9.77062 18.8302L3.72062 12.8062C3.45298 12.5397 3.42863 12.1216 3.64759 11.8276L3.72057 11.7433L9.77057 5.71833C10.0641 5.42604 10.5389 5.42703 10.8312 5.72052C11.0969 5.98734 11.1203 6.40406 10.9018 6.69721L10.829 6.78118L5.313 12.2751L10.829 17.7673Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.8ec71290f20656c379a59b2fc75a532e.svg";
export { ForwardRef as ReactComponent };